/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseFileFieldLook = {
    TextLook: 'FILE_FIELD_TEXT_LOOK',
    IconLook: 'FILE_FIELD_ICON_LOOK'
} as const;
export type DatabaseFileFieldLook = typeof DatabaseFileFieldLook[keyof typeof DatabaseFileFieldLook];


export function DatabaseFileFieldLookFromJSON(json: any): DatabaseFileFieldLook {
    return DatabaseFileFieldLookFromJSONTyped(json, false);
}

export function DatabaseFileFieldLookFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFileFieldLook {
    return json as DatabaseFileFieldLook;
}

export function DatabaseFileFieldLookToJSON(value?: DatabaseFileFieldLook | null): any {
    return value as any;
}

